/** @jsx jsx */

import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import { GridLayout } from '@zapier/common-components';
import { jsx } from '@emotion/core';

import FilterRuleEditorField from 'app/beta-editor/components/formatic/FilterRuleEditorField';
import FilterRuleEditorStyles from 'app/beta-editor/components/formatic/FilterRuleEditorStyles';
import Icon from 'app/common/components/Icon';
import ruleMatchChoices from 'app/beta-editor/ruleMatchChoices';
import { Div } from 'app/common/components/AccessibleElement.js';

const doesMatchSupportValues = match => !/iexist|boolean/.test(match);

const FilterRuleEditor = createReactClass({
  displayName: 'FilterRuleEditor',
  mixins: [PureRenderMixin],

  propTypes: {
    config: PropTypes.object.isRequired,
    field: PropTypes.object.isRequired,
    ruleId: PropTypes.number.isRequired,
    ruleKey: PropTypes.string,
    ruleMatch: PropTypes.oneOf(Object.keys(ruleMatchChoices).concat('')),
    ruleNumber: PropTypes.number.isRequired,
    ruleValue: PropTypes.string,
    onAction: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  },

  onChange(value, info) {
    this.props.onChange(this.props.ruleId, value, info.field.key, info);
  },

  onDelete() {
    this.props.onDelete(this.props.ruleId);
  },

  render() {
    const hasValueField = doesMatchSupportValues(this.props.ruleMatch);

    // ensures columns have a minimum width (left number) and max width (right number)
    const minMaxColumnWidth = 'minmax(0, 161px)';

    const narrowGridQueries = {
      '(max-width: 700px)': {
        areas: `
         "input button"
         "rule ."
         "value ."
        `,
        row: 'auto',
        columns: '90% 10%',
      },
    };

    const narrowColumnQueries = {
      '(max-width: 700px)': {
        columns: 'minmax(0, 1fr)',
      },
    };

    return (
      <div style={FilterRuleEditorStyles.root}>
        <GridLayout
          areas={`
          "input rule value button"
        `}
          columns={`repeat(3, ${minMaxColumnWidth}) 50px`}
          gap={8}
          propsQueries={narrowGridQueries}
        >
          <div className="flowform rule-cell">
            <GridLayout
              area="input"
              columns={minMaxColumnWidth}
              propsQueries={narrowColumnQueries}
            >
              <FilterRuleEditorField
                config={this.props.config}
                field={this.props.field}
                onAction={this.props.onAction}
                onChange={this.onChange}
                type="key"
                value={this.props.ruleKey}
              />
            </GridLayout>
          </div>
          <GridLayout area="button">
            <Div
              aria-label="delete filter criteria"
              onClick={this.onDelete}
              role="button"
            >
              <div css={FilterRuleEditorStyles.deleteButton}>
                <Icon type="delete" />
              </div>
            </Div>
          </GridLayout>
          <div className="flowform rule-cell">
            <GridLayout
              area="rule"
              columns={minMaxColumnWidth}
              propsQueries={narrowColumnQueries}
            >
              <FilterRuleEditorField
                config={this.props.config}
                field={this.props.field}
                onAction={this.props.onAction}
                onChange={this.onChange}
                type="match"
                value={this.props.ruleMatch}
              />
            </GridLayout>
          </div>
          {hasValueField ? (
            <GridLayout area="value">
              <FilterRuleEditorField
                config={this.props.config}
                field={this.props.field}
                onAction={this.props.onAction}
                onChange={this.onChange}
                type="value"
                value={this.props.ruleValue}
              />
            </GridLayout>
          ) : null}
        </GridLayout>
      </div>
    );
  },
});

export default FilterRuleEditor;
